import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlassian/ufo';
import type { AbstractExperienceConfig } from '@atlassian/ufo-experimental/dist/types/platform-client/core/experience/abstract-experience';

// TODO: add @typescript-eslint/no-shadow ref https://github.com/typescript-eslint/typescript-eslint/issues/2483
// eslint-disable-next-line no-shadow
export enum Experience {
    RENDER_EDITOR_ELEMENT = 'EDITOR',
    RENDER_HERO_ELEMENT = 'HERO',
    RENDER_ANNOUNCEMENT_ELEMENT = 'ANNOUNCEMENT',
    RENDER_TOPICS_LIST_ELEMENT = 'TOPICS_LIST',
    RENDER_PORTALS_LIST_ELEMENT = 'PORTALS_LIST',
    RENDER_SUGGESTED_REQUEST_FORMS_LIST_ELEMENT = 'SUGGESTED_REQUEST_FORMS_LIST',
    RENDER_FORGE_ELEMENT = 'FORGE',
    RENDER_NO_CONTENT_ELEMENT = 'NO_CONTENT',
    RENDER_BREADCRUMB_ELEMENT = 'BREADCRUMB',
    RENDER_UNKNOWN_ELEMENT = 'UNKNOWN',
}

export interface UFOExperienceOptions {
    experienceId: string;
    config: AbstractExperienceConfig;
}

export const EXPERIENCE_CONFIGS: Record<Experience, UFOExperienceOptions> = {
    [Experience.RENDER_EDITOR_ELEMENT]: {
        experienceId: 'service-management.help-center.element.EDITOR',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_HERO_ELEMENT]: {
        experienceId: 'service-management.help-center.element.HERO',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_ANNOUNCEMENT_ELEMENT]: {
        experienceId: 'service-management.help-center.element.ANNOUNCEMENT',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_TOPICS_LIST_ELEMENT]: {
        experienceId: 'service-management.help-center.element.TOPICS_LIST',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_PORTALS_LIST_ELEMENT]: {
        experienceId: 'service-management.help-center.element.PORTALS_LIST',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_SUGGESTED_REQUEST_FORMS_LIST_ELEMENT]: {
        experienceId: 'service-management.help-center.element.SUGGESTED_REQUEST_FORMS_LIST',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_FORGE_ELEMENT]: {
        experienceId: 'service-management.help-center.element.FORGE',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_NO_CONTENT_ELEMENT]: {
        experienceId: 'service-management.help-center.element.NO_CONTENT',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_UNKNOWN_ELEMENT]: {
        experienceId: 'service-management.help-center.element.UNKNOWN',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
    [Experience.RENDER_BREADCRUMB_ELEMENT]: {
        experienceId: 'service-management.help-center.element.BREADCRUMB',
        config: {
            type: ExperienceTypes.Load,
            performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
        },
    },
};
